/* eslint-disable no-unused-vars */
import styled, { css } from 'styled-components';
import { Palette } from 'config';

export const TableContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
  color: ${Palette.PrimaryGray._500};
  background: ${Palette.PrimaryGray._000};
  height: ${({ size }) => size && size};
  padding: 0 4px;
  width: ${({ width }) => (width ? `${width}px` : '100%')};
`;

export const Content = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;
  transform: translateX(2px);
  svg {
    transform: rotate(180deg);
  }
  :hover {
    color: ${Palette.PrimaryGray._700};
    svg {
      fill: ${Palette.PrimaryGray._500};
    }
  }
  ${({ direction }) => {
    if (direction === 'ascending')
      return css`
        svg {
          fill: ${Palette.Primary._500};
          transform: rotate(0deg);
        }
      `;
    if (direction === 'descending')
      return css`
        svg {
          fill: ${Palette.Primary._500};
        }
      `;
  }}
  svg {
    transition: transform 0.2s linear;
  }
`;
